/**
 * Email cache generation ("epoch") — bumped by the identity-boundary purge
 * (features/auth clearEmailCaches: logout + container switch) so mounted email
 * hooks can detect that their in-memory caches predate a purge (#5295, the
 * reload:false container-sync path keeps the module mounted). Hooks capture
 * the epoch when seeding their refs from sessionStorage; on a mismatch they
 * must drop the seeded rows and never re-persist them into the just-cleared
 * storage. Module-scoped mutable counter — React-free, importable by both
 * features/auth (the bump) and modules/email (the readers) without a
 * peer-feature import.
 */

let emailCacheEpoch = 0;

export function getEmailCacheEpoch(): number {
  return emailCacheEpoch;
}

export function bumpEmailCacheEpoch(): void {
  emailCacheEpoch += 1;
}
